import { useEffect } from 'react'
import { Link } from '@mui/material'
import { BaseGridLayout } from '@lucan/base-ui'
import { ELENCHI } from 'configuration/ConfigurazioneElenchi'
import { CHIAVI_SESSIONE } from 'configuration/ConfigurazioneSessione'
import { LINK_ACCESSO } from 'configuration/link'
import BottoneSPID from 'components/SPID/BottoneSPID'
import BottoneCIE from 'components/CIE/BottoneCIE'
import ConfigManager from 'components/config/ConfigManager'
import Breadcrumbs from 'components/ui/Breadcrumbs'
import LineaSeparatrice from 'components/ui/LineaSeparatrice'
import Testo from 'components/ui/Testo'
import Titolo from 'components/ui/Titolo'
import Titolone from 'components/ui/Titolone'
import { useSessione } from 'context/SessioneProvider'
import AccessoChiaveVerbale from './AccessoChiaveVerbale'
import AccessoCodiceFiscaleTest from './AccessoCodiceFiscaleTest'
import { useAppContext } from 'GlobalContext'

const CFG = LINK_ACCESSO

export default function Accesso(props) {
  const {
    attivo,
    spidAttivo,
    cieAttivo,
    chiaveWebAttivo,
    propsChiaveWeb,
    chiaveRottaDopoAccesso,
    altreModalita,
  } = props
  const { intermediario } = useAppContext() 
  const { salvaInSessione, pulisciSessione } = useSessione()

  useEffect(() => {
    pulisciSessione()
    salvaInSessione(CHIAVI_SESSIONE.CHIAVE_ROTTA_DOPO_ACCESSO, chiaveRottaDopoAccesso)
    salvaInSessione(CHIAVI_SESSIONE.CHIAVE_ROTTA_HOME_SERVIZIO, window.location.href)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [chiaveRottaDopoAccesso])

  return (
    <ConfigManager
      elenchiConfig={[ELENCHI.CFG_LINK_ACCESSO]}
      render={({ val, txt }) =>

        attivo ? 
          <BaseGridLayout vertical spacing={4}>
            <Breadcrumbs sx={{ mb: 3 }} {...val(CFG.BREADCRUMBS)} />

            <>
              <Titolone>{txt(CFG.TITOLO)}</Titolone>
              <Testo>{txt(CFG.DESCRIZIONE)}</Testo>
              <LineaSeparatrice />
            </>

            {spidAttivo  && intermediario &&
              <>
                <Titolo>{txt(CFG.SPID_TITOLO)}</Titolo>
                <Testo>{txt(CFG.SPID_DESCRIZIONE)}</Testo>
                <BottoneSPID />
                <Link href='https://www.spid.gov.it/cos-e-spid/come-attivare-spid/' target='_blank' sx={{ display: 'block', width: 'fit-content' }}>
                  {txt(CFG.SPID_COME_RICHIEDERE)}
                </Link>
              </>
            }

            {cieAttivo && intermediario &&
              <>
                <Titolo>{txt(CFG.CIE_TITOLO)}</Titolo>
                <Testo>{txt(CFG.CIE_DESCRIZIONE)}</Testo>
                <BottoneCIE />
                <Link href='https://www.cartaidentita.interno.gov.it/richiedi/' target='_blank' sx={{ display: 'block', width: 'fit-content' }}>
                  {txt(CFG.CIE_COME_RICHIEDERE)}
                </Link>
              </>
            }

            {chiaveWebAttivo &&
              <AccessoChiaveVerbale
                val={val} txt={txt}
                chiaveRottaDopoAccesso={chiaveRottaDopoAccesso}
                {...propsChiaveWeb}
              />
            }

            {process.env.REACT_APP_ENV_NAME !== 'prod' &&
              <>
                <Titolo>TEST</Titolo>
                <Testo>Scegli un codice fiscale di test</Testo>
                <AccessoCodiceFiscaleTest />
              </>
            }

            {altreModalita}
          </BaseGridLayout>
        
        :<>
         <Titolone>{txt(CFG.TITOLO_NO_SERVIZIO)}</Titolone>
         <Testo>{txt(CFG.DESCRIZIONE_NO_SERVIZIO)}</Testo>
        </>

      }
    />
  )
}